/**
 * Parses an agent response string that may contain extended markdown
 * with embedded dashbo blocks (fenced code blocks with `dashbo:TYPE` prefix).
 *
 * Returns an array of segments:
 *   { type: 'markdown', content: string }
 *   { type: 'block', blockType: string, data: object, error?: string }
 */
export function parseDashboMessage(text) {
    if (!text) return [{ type: 'markdown', content: '' }];

    const BLOCK_RE = /```dashbo:(\w+)\n([\s\S]*?)```/g;

    const segments = [];
    let lastIndex = 0;
    let match;

    while ((match = BLOCK_RE.exec(text)) !== null) {
        // Markdown text before this block
        if (match.index > lastIndex) {
            const md = text.slice(lastIndex, match.index);
            if (md.trim()) {
                segments.push({ type: 'markdown', content: md });
            }
        }

        const blockType = match[1];
        const rawJson = match[2].trim();

        let data = null;
        let error = undefined;
        try {
            data = JSON.parse(rawJson);
        } catch (e) {
            error = rawJson;
        }

        segments.push({ type: 'block', blockType, data, error });
        lastIndex = match.index + match[0].length;
    }

    // Trailing markdown after the last block (or entire text if no blocks)
    if (lastIndex < text.length) {
        const md = text.slice(lastIndex);
        if (md.trim()) {
            segments.push({ type: 'markdown', content: md });
        }
    }

    // Fallback: if nothing was produced, return the raw text
    if (segments.length === 0) {
        segments.push({ type: 'markdown', content: text });
    }

    return segments;
}
